import DOMPurify from "isomorphic-dompurify";
import { HeadingLevel, Layout } from "@viagogo/core/ui";
import {
  BodyWrapper,
  PolicyTitle,
  PolicyWrapper,
  SectionContent,
  SectionDiv,
  SectionTitle,
  TextWrapper,
} from "src/website-apps/responsive/stubhub-policy/components/styled-components";
import { usePolicyPageModelData } from "src/website-apps/responsive/stubhub-policy/hooks/usePolicyPageModelData";
import { LazyFooter } from "src/website-apps/shared/components/footer";
import { HeaderConfiguration } from "src/website-apps/shared/components/header";

// Wrap each table in a horizontal-scroll container so wide data tables (e.g. the
// privacy data-sharing table) scroll on their own on small screens instead of
// overflowing the page or squeezing columns down to one word per line. Runs on
// already-sanitized markup, so the added wrapper is trusted static HTML.
const wrapTablesForScroll = (html: string): string =>
  html.replaceAll(/<table/gi, '<div class="table-scroll"><table').replaceAll(/<\/table>/gi, "</table></div>");

export const App = () => {
  const model = usePolicyPageModelData();
  return (
    <HeadingLevel>
      <Layout
        header={<HeaderConfiguration.Simple />}
        body={
          <BodyWrapper>
            <TextWrapper>
              <PolicyTitle>{model.policyTitle}</PolicyTitle>
              <PolicyWrapper>
                {model.policySections.map((section) => (
                  <SectionDiv key={section.sectionTitle} id={section.sectionTitle?.split(" ").join("")}>
                    <SectionTitle
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(`${section.sectionNumber ?? ""} ${section.sectionTitle ?? ""}`),
                      }}
                    />
                    <SectionContent>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: wrapTablesForScroll(DOMPurify.sanitize(section.sectionText ?? "")),
                        }}
                      />
                    </SectionContent>
                  </SectionDiv>
                ))}
              </PolicyWrapper>
            </TextWrapper>
          </BodyWrapper>
        }
        footer={
          <LazyFooter
            companyLinks={model.footer?.companyLinks}
            supportLinks={model.footer?.supportLinks}
            getLocationSettingsUrl={model.footer?.getLocationSettingsUrl}
          />
        }
      />
    </HeadingLevel>
  );
};
